// export const domain = "http://localhost:4000/api"

export const domain = "https://bewelll.com/api"